const mutations = {
  // 设置公告列表
  muSetMessage(state, payload) {
    state.message = payload;
  },

  // 设置上规格信息
  muSetUpSpecil(state, data) {
    state.upSpecil = data;
  },

  // 设置选中的skuid
  muChooseUpSpecil(state, data) {
    state.chooseUpSpecil = data;
  },

  // 具体信息
  muDetailInfo(state, data) {
    state.campDetailInfo = data;
  },

  // 是否售罄
  muSellOut(state, status) {
    state.isSellOut = status;
  },

  // 设置swiperPage
  muSwiperPage(state, data) {
    state.swiperPage = data;
  },
};
export default mutations;
